import "./DateGroups.css";
import React, { useMemo } from "react";
import { formatMeetingLabelTs, toIsoDate } from "../utils/dateHelpers";
import RequestCard from "./RequestCard";

const Badge = ({ count }) => (
  <span className="badge-blue">
    {count} demande{count > 1 ? "s" : ""}
  </span>
);

const DateGroups = ({ requests, onCardClick, onTakeClick, onAskEdit, highlightMap, selectedMeetingAt }) => {
  const groups = useMemo(() => {
    try {
      console.log("🔍 DateGroups reçoit:", requests?.length || 0, "requests:", requests);
      const byIso = new Map();
      // Filtrer les requêtes valides
      const validRequests = (requests || []).filter((r) => {
        if (!r) {
          console.log("❌ Request null/undefined:", r);
          return false;
        }
        if (!r.id) {
          console.log("❌ Request sans id:", r);
          return false;
        }
        if (!r.meetingAt && !r.isoDate) {
          console.log("❌ Request sans meetingAt ni isoDate:", r);
          return false;
        }
        return true;
      });
      console.log("✅ DateGroups validRequests:", validRequests?.length || 0, validRequests);

      for (const r of validRequests) {
        const iso = r.isoDate || toIsoDate(r.meetingAt);
        if (!byIso.has(iso)) byIso.set(iso, []);
        byIso.get(iso).push(r);
      }

      const arr = Array.from(byIso.entries()).map(([iso, list]) => {
        // Trier par heure de réunion pour avoir la bonne heure dans le titre
        const sortedByMeetingTime = list.sort((a, b) => (a.meetingAt || 0) - (b.meetingAt || 0));
        
        // Trouver la première demande de ce groupe pour avoir l'heure correcte
        const firstRequest = sortedByMeetingTime[0];
        const correctTimestamp = firstRequest?.meetingAt || 0;
        
        console.log(`📅 [DateGroups] Groupe ${iso}: heure correcte = ${new Date(correctTimestamp).toLocaleString('fr-FR')}`);
        
        const totalPlaces = sortedByMeetingTime.reduce((sum, r) => {
          const remaining = Number(
            r.seatsRemaining ??
            ((r.seatsNeeded || 0) - (r.seatsAssigned || 0))
          );
          return sum + (Number.isFinite(remaining) && remaining > 0 ? remaining : 0);
        }, 0);

        return {
          iso,
          firstTs: correctTimestamp,
          list: sortedByMeetingTime,
          totalPlaces,
        };
      });

      arr.sort((a, b) => a.firstTs - b.firstTs);
      return arr;
    } catch (error) {
      console.error("Erreur lors du groupement des demandes:", error);
      return [];
    }
  }, [requests]);

  if (!requests || requests.length === 0) {
    return (
      <div
        className="group-card empty-state animate-fade-in-up"
        style={{ textAlign: "center", padding: "24px 12px", color: "#6b7280" }}
      >
        <div style={{ fontSize: 32, marginBottom: 8 }}>📭</div>
        <div>Aucune demande en attente pour la période sélectionnée</div>
      </div>
    );
  }

  return (
    <React.Fragment>
      {groups.map((g) => {
        const variant = highlightMap?.get(g.firstTs) ?? "default";
        const titleClass = [
          "group-title",
          variant === "closest" ? "title-closest" : "",
          variant === "eve" ? "title-eve" : "",
        ]
          .join(" ")
          .trim();

        return (
        <section key={`grp-${g.iso}`} className="group-card animate-fade-in-up">
          <ul className="group-list space-y-3">
            {g.list.map((r) => (
              <li key={r.id} className="req-item animate-fade-in-up">
                <RequestCard
                  request={r}
                  onClick={onCardClick ? () => onCardClick(r) : undefined}
                  onTakeClick={onTakeClick ? () => onTakeClick(r) : undefined}
                  onAskEdit={onAskEdit ? () => onAskEdit(r) : undefined}
                  variant="pending"
                  compact
                />
              </li>
            ))}
          </ul>
        </section>
        );
      })}
    </React.Fragment>
  );
};

export default DateGroups;
